var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React from 'react';
import { Table } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
export var AppTable = function (_a) {
    var scrollHeight = _a.scrollHeight, tableHeader = _a.tableHeader, tableData = _a.tableData, className = _a.className, settings = _a.settings, scrollOptions = _a.scrollOptions;
    var ths = tableHeader.map(function (item) { return item; });
    var data = tableData && tableData.length > 0 ? tableData :
        (React.createElement("tr", null,
            React.createElement("td", { className: 'text-center', colSpan: ths.length },
                React.createElement(FormattedMessage, { id: 'table.nodata' }))));
    var styles = scrollHeight ? { height: scrollHeight } : undefined;
    var scrollCustomOptions = scrollOptions ? { overflowBehavior: scrollOptions, paddingAbsolute: true } : undefined;
    return (React.createElement(OverlayScrollbarsComponent, { style: __assign(__assign({}, styles), { paddingBottom: '8px' }), options: scrollCustomOptions },
        React.createElement(Table, { className: "app-table " + (className || ''), hover: true },
            React.createElement("thead", null,
                React.createElement("tr", { className: 'table-tr_color' }, ths)),
            React.createElement("thead", { className: 'thead-settings' }, settings),
            React.createElement("tbody", null, data))));
};
//# sourceMappingURL=app-table.js.map